import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { DisclosureActions } from './disclosure.actions';

@Injectable({
  providedIn: 'root'
})
export class DisclosureEffects {
  sendDisclosureEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendDisclosureEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(DisclosureActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
